import React from 'react';
import styled from 'styled-components';
import { IconChevronDown } from '@tabler/icons-react';
import { Select, Icon } from 'opencare-crown';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { BRAND_COLORS } from 'brand-guidelines/colors';

export const StyledSelect = styled(Select).attrs({
  size: 'large',
  bordered: true,
  listHeight: 282, // Equivalent to max-height. 282px is ~8 options
  suffixIcon: <IconChevronDown size={16} color={BRAND_COLORS.darkGray} />,
  dropdownStyle: {
    borderRadius: '8px',
    border: `1px solid ${BRAND_COLORS.darkGray}`,
  },
})`
  width: 100%;

  border-radius: 8px;

  &:focus-visible,
  &:focus-within {
    border-color: ${BRAND_COLORS.darkGreen};
    outline: none !important; /* antd uses !important so we have to as well */
  }

  /* Selected item styles */
  && {
    && {
      .ant-select-selector {
        padding: 0;
        width: 100%;
        overflow: hidden;
        border-radius: 8px;
        border-color: ${BRAND_COLORS.darkGray};

        .ant-select-selection-item {
          display: contents;
        }
      }
    }
  }

  /* Arrow styles */
  && {
    && {
      .ant-select-arrow {
        /* This is set up to cover any text that could overlap the arrow */
        position: absolute;
        height: calc(100% - 2px);
        width: 24px;
        top: 1px;
        right: 1px;

        display: flex;
        justify-content: center;
        align-items: center;

        background-color: ${BRAND_COLORS.white};

        margin-top: 0;
        border-radius: 0 8px 8px 0;
      }
    }
  }

  /* Option styles */
  .ant-select-item.ant-select-item-option {
    padding: 0;
    background: 0;

    &:hover {
      background-color: ${BRAND_COLORS.dirtyWhite};
    }
    &.ant-select-item-option-selected {
      background-color: ${BRAND_COLORS.ashGreen};
    }
  }

  /* Group styles */
  .option-group {
    padding: 0;
    background: 0;
  }
`;

export const OptionGroupInDropdown = styled.div`
  display: contents;

  ${StyledSelect} .ant-select-selection-item & {
    display: none;
  }
`;

export const OptionGroupInSelect = styled.div`
  display: none;

  ${StyledSelect} .ant-select-selection-item & {
    display: contents;
  }
`;

export const OptionText = styled.span`
  color: ${BRAND_COLORS.darkGray};
  ${TYPOGRAPHY.CIRCULAR.book};
  font-size: 14px;
  line-height: 22px;

  ${OptionGroupInDropdown} & {
    ${TYPOGRAPHY.CIRCULAR.bold};
    color: ${BRAND_COLORS.darkStroke};
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  width: 100%;

  padding: 6px 12px;

  line-height: 1;
`;

export const JustifySelfRight = styled.div`
  margin-left: auto;
`;

export const InstantBookIcon = styled(Icon)`
  color: ${BRAND_COLORS.red};
`;
